import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEn from '../locales/en/common.json';
import homepageEn from '../locales/en/homepage.json';
import productsEn from '../locales/en/products.json';
import categoriesEn from '../locales/en/categories.json';
import cartEn from '../locales/en/cart.json';
import checkoutEn from '../locales/en/checkout.json';
import authEn from '../locales/en/auth.json';
import accountEn from '../locales/en/account.json';
import sellerEn from '../locales/en/seller.json';
import pagesEn from '../locales/en/pages.json';
import cookiesEn from '../locales/en/cookies.json';
import commonGr from '../locales/gr/common.json';
import homepageGr from '../locales/gr/homepage.json';
import productsGr from '../locales/gr/products.json';
import categoriesGr from '../locales/gr/categories.json';
import cartGr from '../locales/gr/cart.json';
import checkoutGr from '../locales/gr/checkout.json';
import authGr from '../locales/gr/auth.json';
import accountGr from '../locales/gr/account.json';
import sellerGr from '../locales/gr/seller.json';
import pagesGr from '../locales/gr/pages.json';
import cookiesGr from '../locales/gr/cookies.json';


const resources = {
  en: {
    common: commonEn,
    homepage: homepageEn,
    products: productsEn,
    categories: categoriesEn,
    cart: cartEn,
    checkout: checkoutEn,
    auth: authEn,
    account: accountEn,
    seller: sellerEn,
    pages: pagesEn,
    cookies: cookiesEn,
  },
  gr: {
    common: commonGr,
    homepage: homepageGr,
    products: productsGr,
    categories: categoriesGr,
    cart: cartGr,
    checkout: checkoutGr,
    auth: authGr,
    account: accountGr,
    seller: sellerGr,
    pages: pagesGr,
    cookies: cookiesGr,
  },

};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
